import { render, staticRenderFns } from "./Areaslot.vue?vue&type=template&id=cf0b4126&scoped=true"
import script from "./Areaslot.vue?vue&type=script&lang=js"
export * from "./Areaslot.vue?vue&type=script&lang=js"
import style0 from "./Areaslot.vue?vue&type=style&index=0&id=cf0b4126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0b4126",
  null
  
)

export default component.exports